import React, { useEffect, useMemo } from "react";
import { useGetAllProviderQuery } from "../../services/chatService";
import { ReactSelectField } from "../reactHookFormFields/selectField";
import { useGroupChatContext } from "../../context/groupchatContext";
import { useWatch } from "react-hook-form";
import { CheckBox } from "../reactHookFormFields/checkbox";
import { PatientSearchField } from "../reactHookFormFields/patientSearchField";

const TaskForm = React.memo(({formHandler}) => {

    const groupChatContext = useGroupChatContext();
    const {selectedChatTab, selectedChat} = useMemo(() => ({
        selectedChatTab: groupChatContext.selectedChatTab,
        selectedChat: groupChatContext.selectedChat,
    }));

    const {data: allProviders } = useGetAllProviderQuery();
    const providerOptions = allProviders?.map(provider => ({
        value: provider.User.id,
        label: provider.User.name
    }));

    const assigneeProviderVal = useWatch({ control: formHandler.control, name: "assignee_provider" });

    useEffect(()=>{
        if(assigneeProviderVal?.length < 2){
            formHandler.setValue('auto_complete_all', false)
        }
    }, [assigneeProviderVal])

    return (
        <form>
            <div className="items-center">
                <div className="flex flex-wrap gap-2 items-center">
                    <div className='w-1/2'>
                        <ReactSelectField
                            title="Provider"
                            name="assignee_provider"
                            isMulti={true}
                            control={formHandler.control}
                            optionData={providerOptions?.map((v, k) => ({
                                ...v,
                                label: v.label,
                            }))}
                            menuPlacement={"bottom"}
                            rules={{
                                required: {
                                value: true,
                                //  message: "please select provider",
                                },
                            }}
                            errors={formHandler.errors}
                        />
                    </div>
                    {selectedChatTab == 'location_chats' ? 
                        <div className='w-[49%]'>
                            <PatientSearchField
                                title="Patient Search"
                                name="patient"
                                control={formHandler.control}
                                location={selectedChat?.location?.id}
                                rules={{
                                    required: {
                                        value: true,
                                    },
                                }}
                                errors={formHandler.errors}
                            />
                        </div>
                        : null
                    }
                    {assigneeProviderVal?.length > 1 ?
                        <div>
                            <CheckBox
                                title="Auto Complete for everyone when one assignee completes"
                                name="auto_complete_all"
                                control={formHandler.control}
                                disabled={!assigneeProviderVal?.length}
                            />
                        </div>
                        : null
                    }
                </div>
            </div>
        </form>
    )
})

export default TaskForm;
